
import { css } from 'lit';
export default css`
:host {
  display: flex;
  height: 100%;
}

.btn__link {
  display: inline-flex;
  border-bottom-width: 1px;
  border-color: transparent;
  font-family: Lato, sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
  text-decoration: none;
}

@media (min-width: 1024px) {

  .btn__link {
    font-size: 1.25rem;
  }
}

.btn__link:hover {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.btn__link:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

.btn__link--icon-left {
  order: -9999;
}

.btn__link--icon-left {
  margin-right: 0.75rem;
}

.btn__link--external {
    display: inline-flex;
    align-items: center;
  }

.btn__link .link--external__icon {
    width: 1rem;
    height: 1rem;
    margin-left: 0.5rem;
  }

.btn__link--right-arrow-links, .btn__link--icon-right {
  order: 9999;
}

.btn__link--right-arrow-links, .btn__link--icon-right {
  margin-left: 0.5rem;
}

.btn__link.location-card-phone {
    font-size: 1.125rem;
  }

.btn__link__icon {
  margin-left: 0.5rem;
}

.btn__link__icon {
  height: 1rem;
}

.btn__link__icon {
  width: 1rem;
}

.btn__link__icon {
  align-self: center;
}

@media (min-width: 1024px) {

.btn__link__icon {
      margin-left: 13px
  }

      .btn__link__icon.icon-btn__link--pager-button.btn__link--icon-left {
        margin-left: 0;
        margin-right: 13px;
      }
    }

@media (min-width: 1024px) {

  .btn__link__icon[name="phone"] {
    margin-top: 2px;
  }
}

@media (min-width: 1024px) {

  .btn__link__icon--alternate {
    --tw-text-opacity: 1;
    color: rgba(35, 35, 35, var(--tw-text-opacity));
  }
}

.btn__link__icon.icon-btn__link--icon-navigation-location-card[name="location"] {
      width: 19px;
      height: 23px;
      margin-top: 5px;
    }

.btn__link__icon.icon-btn__link--icon-navigation-location-card[name="phone"] {
      width: 16px;
      height: 16px;
    }

@media (min-width: 1024px) {
      .btn__link__icon[name="phone"].icon-btn__link--icon-navigation-secondary {
        margin-top: 1px;
        height: 20px;
        width: 20px;
      }

      .btn__link__icon[name="avatar"].icon-btn__link--icon-navigation-secondary {
        width: 24px;
        height: 22px;
      }

      .btn__link__icon[name="globe"].icon-btn__link--icon-navigation-secondary {
        width: 25px;
        height: 23px;
      }
    }

.btn__link--icon-navigation-location-card {
  margin-top: 2px;
}

.btn__link--icon-navigation-location-card:hover {
  border-width: 0px;
}

.btn__link--header-logo {
  width: 12rem;
}

.btn__link--header-logo {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

.btn__link--header-logo:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

.btn__link--nav-mobile-toggle {
  display: flex;
}

.btn__link--nav-mobile-toggle {
  padding: 1rem;
}

.btn__link--nav-mobile-toggle {
  font-size: 1rem;
}

.btn__link--nav-mobile-toggle {
  font-weight: 400;
}

.btn__link--nav-mobile-toggle {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--nav-mobile-toggle:hover {
  cursor: pointer;
}

.btn__link--nav-mobile-toggle:hover {
  border-color: transparent;
}

.btn__link--nav-mobile-toggle:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

@media (min-width: 640px) {

  .btn__link--nav-mobile-toggle {
    padding: 1.5rem;
  }
}

@media (min-width: 640px) {

  .btn__link--nav-mobile-toggle {
    font-size: 1.125rem;
  }
}

@media (min-width: 640px) {

  .btn__link--nav-mobile-toggle {
    font-weight: 700;
  }
}

.btn__link--nav-mobile-toggle .btn__link__icon {
  margin-left: 1rem;
}

@media (min-width: 640px) {

  .btn__link--nav-mobile-toggle .btn__link__icon {
    margin-left: 1.5rem;
  }
}

.btn__link--icon-navigation-icon-grid {
  width: 100%;
}

.btn__link--icon-navigation-icon-grid {
  border-width: 0px;
}

.btn__link--icon-navigation-icon-grid {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.btn__link--icon-navigation-icon-grid {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

.btn__link--icon-navigation-icon-grid {
    -webkit-hyphens: none;
        -ms-hyphens: none;
            hyphens: none
  }

.btn__link--icon-navigation-icon-grid {
  font-size: 1rem;
}

.btn__link--icon-navigation-icon-grid {
  font-weight: 400;
}

@media (min-width: 768px) {

  .btn__link--icon-navigation-icon-grid {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}

@media (min-width: 768px) {

  .btn__link--icon-navigation-icon-grid {
    font-size: 1.125rem;
  }
}

@media (min-width: 768px) {

  .btn__link--icon-navigation-icon-grid {
    font-weight: 700;
  }
}

@media (min-width: 1024px) {

  .btn__link--icon-navigation-icon-grid {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

.btn__link--icon-navigation-icon-grid:hover {
  border-color: transparent;
}

.btn__link--icon-navigation-icon-grid:hover {
  text-decoration: underline;
}

.btn__link--icon-navigation-icon-grid .btn__link__icon {
  margin-top: 2px;
}

.btn__link--icon-navigation-icon-grid .btn__link__icon {
  height: 1.5rem;
}

.btn__link--icon-navigation-icon-grid .btn__link__icon {
  width: 1.5rem;
}

.btn__link--icon-navigation-icon-grid .btn__link__icon {
  align-self: flex-start;
}

.btn__link--icon-navigation-icon-grid .btn__link__icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn__link--icon-navigation-icon-grid .btn__link__icon {
      min-width: 24px;
    }

.btn__link--icon-navigation-icon-grid ::slotted(span) {
  align-self: flex-start;
}

.btn__link--cta-links .btn__link__icon {
  margin-left: 18px;
}

.btn__link--hero-cta-links {
  font-weight: 400;
}

.btn__link--hero-cta-links {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--hero-cta-links:hover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.btn__link--hero-cta-links:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--icon-navigation:hover {
  border-color: transparent;
}

.btn__link--icon-navigation:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

.btn__link--icon-navigation-secondary {
  align-items: center;
}

.btn__link--icon-navigation-secondary {
  padding-top: 0px;
  padding-bottom: 0px;
}

.btn__link--icon-navigation-secondary {
      padding-left: 6px;
      padding-right: 6px;
    }

@media (min-width: 1440px) {

.btn__link--icon-navigation-secondary {
        padding-left: 12px;
        padding-right: 12px
    }
      }

/* Used for location-card */

.btn__link--icon-navigation-secondary__small--no-padding {
  white-space: nowrap;
}

.btn__link--icon-navigation-secondary__small--no-padding {
  font-size: 0.9375rem;
}

.btn__link--icon-navigation-secondary__small--no-padding .btn__link__icon {
  margin: 0px;
}

.btn__link--icon-navigation-secondary__small--no-padding .btn__link__icon {
  margin-right: 0.5rem;
}

.btn__link--icon-navigation-secondary__small--no-padding .btn__link__icon {
  height: 100%;
}

.btn__link--icon-navigation-secondary:hover, .btn__link--icon-navigation-secondary__small--no-padding:hover {
  border-color: transparent;
}

.btn__link--icon-navigation-secondary:hover, .btn__link--icon-navigation-secondary__small--no-padding:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

.btn__link--icon-navigation-alerts {
  font-size: 0.875rem;
}

@media (min-width: 1024px) {

  .btn__link--icon-navigation-alerts {
    font-size: 1.125rem;
  }
}

.btn__link--icon-navigation-alerts:hover {
  text-decoration: none;
}

.btn__link--icon-navigation-alerts .btn__link__icon {
  margin-right: 0.5rem;
}

.btn__link--icon-navigation-alerts .btn__link__icon--emergency {
  --tw-text-opacity: 1;
  color: rgba(211, 18, 41, var(--tw-text-opacity));
}

.btn__link--icon-navigation-alerts .btn__link__icon--warning {
  --tw-text-opacity: 1;
  color: rgba(231, 157, 12, var(--tw-text-opacity));
}

.btn__link--icon-navigation-alerts .btn__link__icon--information {
  --tw-text-opacity: 1;
  color: rgba(0, 123, 231, var(--tw-text-opacity));
}

.btn__link--icon-navigation-alerts .btn__link__icon--disease {
  --tw-text-opacity: 1;
  color: rgba(6, 168, 110, var(--tw-text-opacity));
}

.btn__link--icon-navigation-social {
  padding: 0.25rem;
}

.btn__link--icon-navigation-social:hover {
  border-color: transparent;
}

.btn__link--icon-navigation-social .btn__link__icon {
  margin: 0px;
}

.btn__link--icon-navigation-social .btn__link__icon {
  height: 3rem;
}

.btn__link--icon-navigation-social .btn__link__icon {
  width: 3rem;
}

.btn__link--icon-navigation-social .btn__link__icon {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--icon-navigation-social .btn__link__icon {
        border-radius: 100%;
        position: relative;
      }

.btn__link--icon-navigation-social .btn__link__icon:hover {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn__link--icon-navigation-social .btn__link__icon:hover:before{
            content: '';
            position: absolute;
            display: block;
            border-radius: 100%;
            top: 2%;
            bottom: 2%;
            right: 2%;
            left: 2%;
            background-color: #fff;
          }

.btn__link--cta-featured--gray-purple--even {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--cta-featured--gray-purple--even:hover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.btn__link--cta-featured--gray-purple--even:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--pager-number {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

.btn__link--pager-number {
    margin: 0 10px;
  }

.btn__link--pager-number--active {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn__link--pager-number--active {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--pager-number--active {
      padding: 0 10px;
    }

.btn__link--pager-number--active:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--right-arrow-links {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn__link--right-arrow-links:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

.btn__link--right-arrow-links:hover {
      border-color: rgba(229, 229, 229, 0.7); /* this color is missing */
    }

.btn__link .icon-btn__link--cta-featured--white-gray--even, .btn__link .icon-btn__link--cta-featured--white-gray--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--even {
  margin-left: 0.5rem;
}

.btn__link .icon-btn__link--cta-featured--white-gray--even, .btn__link .icon-btn__link--cta-featured--white-gray--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--even {
  height: 1rem;
}

.btn__link .icon-btn__link--cta-featured--white-gray--even, .btn__link .icon-btn__link--cta-featured--white-gray--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--even {
  width: 1rem;
}

.btn__link .icon-btn__link--cta-featured--white-gray--even, .btn__link .icon-btn__link--cta-featured--white-gray--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--odd, .btn__link .icon-btn__link--cta-featured--gray-purple--even {
  align-self: center;
}

@media (min-width: 1024px) {

.btn__link .icon-btn__link--cta-featured--white-gray--even,
  .btn__link .icon-btn__link--cta-featured--white-gray--odd,
  .btn__link .icon-btn__link--cta-featured--gray-purple--odd,
  .btn__link .icon-btn__link--cta-featured--gray-purple--even {
      margin-left: 13px
  }
    }

.btn__link--hp {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn__link--hp:hover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.btn__link--hp:hover {
  --tw-text-opacity: 1;
  color: rgba(254, 254, 254, var(--tw-text-opacity));
}

.btn__link.benefits-grid {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    position: relative;
  }

.btn__link.benefits-grid ::slotted(span) {
      align-self: center;
      margin-top: 25px;
      font-size: 20px;
      max-width: 150px;
      text-align: center;
    }

.btn__link.benefits-grid ::slotted(span) {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn__link.benefits-grid ::slotted(span) {
      font-weight: 700 !important;
    }

.btn__link.benefits-grid .btn__link__icon {
      margin: 0 auto;
      width: 50px;
      height: 50px;
    }
`;